import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import { FormDefinitions } from "../../api/dtos";

export interface IUserAgentLocationFormByIdRouteProps extends PropsWithChildren {
    userAgentLocationId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const UserAgentLocationFormByIdRoute: FC<IUserAgentLocationFormByIdRouteProps> = ({
    userAgentLocationId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const userAgentLocationIdToUse = (params.userAgentLocationId ? +params.userAgentLocationId : undefined) ?? userAgentLocationId ?? undefined;

    return (
        <ContextFormByIdProvider
            formId={userAgentLocationIdToUse}
            formDefinitionIdentifier={FormDefinitions.UserAgentLocation}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default UserAgentLocationFormByIdRoute;
